import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatRupiah } from "@/lib/constants";
import { ListTree, Waves } from "lucide-react";

export function FinCoa() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/accounting/coa").then((r) => setRows(r.data || [])).catch(() => {}); }, []);
  return (
    <div data-testid="fin-coa-page" className="mx-auto max-w-3xl">
      <h1 className="font-heading flex items-center gap-2 text-[22px] font-extrabold text-[#111827]"><ListTree className="text-[#1E3A5F]" />Chart of Accounts</h1>
      <p className="text-[13px] text-[#475569]">Tampilan baca-saja. Perubahan COA hanya oleh Owner melalui Master Data.</p>
      <div className="mt-3 divide-y divide-[#E2E5EA] rounded-xl border border-[#E2E5EA] bg-white">
        {rows.map((c) => <div key={c.account_code + c.account_name} data-testid="fin-coa-row" className="flex items-center justify-between gap-2 px-3 py-2 text-[14px]"><span><b className="font-mono text-[#1E3A5F]">{c.account_code}</b> · {c.account_name}</span><span className="shrink-0 text-[12px] font-semibold text-[#475569]">{c.account_type}{c.is_posting ? "" : " · header"}</span></div>)}
      </div>
    </div>
  );
}

export function FinCashFlow() {
  const [d, setD] = useState({ rows: [] });
  useEffect(() => { api.get("/accounting/cash-flow", { params: { months: 12 } }).then((r) => setD(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="fin-cashflow-page" className="mx-auto max-w-3xl">
      <h1 className="font-heading flex items-center gap-2 text-[22px] font-extrabold text-[#111827]"><Waves className="text-[#1E3A5F]" />Cash Flow</h1>
      <p className="text-[13px] text-[#475569]">{d.note}</p>
      <div className="mt-3 space-y-2">
        {d.rows.map((r) => (
          <div key={r.period} data-testid={`cf-${r.period}`} className="rounded-xl border border-[#E2E5EA] bg-white p-3">
            <div className="flex items-center justify-between"><b className="text-[16px] text-[#111827]">{r.period}</b><b className={r.net >= 0 ? "text-emerald-700" : "text-rose-700"}>{formatRupiah(r.net)}</b></div>
            <div className="text-[13px] text-[#334155]">Masuk {formatRupiah(r.in)} · Keluar {formatRupiah(r.out)}</div>
            <div className="mt-1 flex flex-wrap gap-1">{Object.entries(r.by_source).map(([k, v]) => <span key={k} className="rounded bg-[#F4F5F7] px-1.5 py-0.5 text-[11px] font-semibold text-[#334155]">{k}: {formatRupiah(v)}</span>)}</div>
          </div>
        ))}
        {d.rows.length === 0 && <p className="py-8 text-center text-[14px] text-[#475569]">Belum ada transaksi.</p>}
      </div>
    </div>
  );
}
